(function(){
  var COOKIE='prspr_wellness_library_unlocked';
  var KLAVIYO_COMPANY_ID='W73KnX';
  var KLAVIYO_LIST_ID='T9CMNh';
  var KLAVIYO_REVISION='2026-07-15';
  var KLAVIYO_SUBSCRIPTION_URL='https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(KLAVIYO_COMPANY_ID);
  var roots=document.querySelectorAll('[data-wl-root]');
  if(!roots.length)return;

  function cookieUnlocked(){return document.cookie.split('; ').some(function(x){return x.indexOf(COOKIE+'=1')===0;});}
  function storageUnlocked(){try{return localStorage.getItem(COOKIE)==='1';}catch(e){return false;}}
  function isUnlocked(){return cookieUnlocked()||storageUnlocked();}
  function persist(){document.cookie=COOKIE+'=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure';try{localStorage.setItem(COOKIE,'1');}catch(e){}}
  function normalizePhone(value){var digits=value.replace(/\D/g,'');if(digits.length===10)return '+1'+digits;if(digits.length>=11&&digits.length<=15)return '+'+digits;return null;}
  function identity(value){value=value.trim();if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))return {kind:'email',properties:{'$email':value.toLowerCase()}};var phone=normalizePhone(value);if(phone)return {kind:'phone',properties:{'$phone_number':phone}};return null;}
  function trackUnlock(found){window._learnq=window._learnq||[];window._learnq.push(['identify',found.properties]);window._learnq.push(['track','Wellness Library Unlocked',{'Unlock Method':found.kind,'Library Guide Count':16,'Source':'The Wellness Library'}]);}

  function subscriptionProfile(found){
    var attributes={
      properties:{
        'Wellness Library Unlocked':true,
        'Wellness Library Unlock Method':found.kind,
        'Wellness Library Guide Count':16,
        'Wellness Library Source':'The Wellness Library'
      },
      subscriptions:{}
    };
    if(found.kind==='email'){
      attributes.email=found.properties.$email;
      attributes.subscriptions.email={marketing:{consent:'SUBSCRIBED'}};
    }else{
      attributes.phone_number=found.properties.$phone_number;
      attributes.subscriptions.sms={marketing:{consent:'SUBSCRIBED'}};
    }
    return attributes;
  }

  function subscribe(found){
    return fetch(KLAVIYO_SUBSCRIPTION_URL,{
      method:'POST',
      headers:{
        'accept':'application/vnd.api+json',
        'content-type':'application/vnd.api+json',
        'revision':KLAVIYO_REVISION
      },
      body:JSON.stringify({
        data:{
          type:'subscription',
          attributes:{
            custom_source:'The Wellness Library',
            profile:{
              data:{
                type:'profile',
                attributes:subscriptionProfile(found)
              }
            }
          },
          relationships:{
            list:{
              data:{type:'list',id:KLAVIYO_LIST_ID}
            }
          }
        }
      })
    }).then(function(response){
      if(response.status===202)return;
      return response.json().catch(function(){return null;}).then(function(body){
        var detail=body&&body.errors&&body.errors[0]&&body.errors[0].detail;
        throw new Error(detail||('Klaviyo subscription failed with status '+response.status));
      });
    });
  }

  function apply(){var unlocked=isUnlocked();roots.forEach(function(root){root.classList.toggle('is-unlocked',unlocked);root.querySelectorAll('[data-wl-guide-link]').forEach(function(link){link.setAttribute('aria-disabled',unlocked?'false':'true');});});}
  function finishUnlock(form){persist();apply();var root=form.closest('[data-wl-root]');if(root&&root.getAttribute('data-wl-view')==='guide'){var content=root.querySelector('[data-wl-guide-content]');if(content){content.setAttribute('tabindex','-1');content.focus({preventScroll:true});window.scrollTo({top:content.getBoundingClientRect().top+window.scrollY-90,behavior:'smooth'});}}else{var library=document.querySelector('[data-wl-library]');if(library)library.scrollIntoView({behavior:'smooth',block:'start'});}}

  document.addEventListener('submit',function(event){
    var form=event.target.closest('[data-wl-form]');
    if(!form)return;
    event.preventDefault();
    if(form.getAttribute('data-wl-submitting')==='true')return;
    var input=form.querySelector('[data-wl-input]');
    var message=form.querySelector('[data-wl-message]');
    var button=form.querySelector('button[type="submit"]');
    var found=identity(input?input.value:'');
    if(!found){
      if(message){message.textContent='Enter a valid email address or mobile phone number.';message.setAttribute('data-kind','error');}
      if(input)input.focus();
      return;
    }
    if(message){message.textContent='Unlocking your library…';message.setAttribute('data-kind','ok');}
    form.setAttribute('data-wl-submitting','true');
    if(button)button.disabled=true;
    trackUnlock(found);
    subscribe(found).then(function(){
      finishUnlock(form);
    }).catch(function(error){
      console.error('Wellness Library Klaviyo subscription error',error);
      if(message){message.textContent='We could not complete your signup. Please try again.';message.setAttribute('data-kind','error');}
      if(input)input.focus();
    }).finally(function(){
      form.removeAttribute('data-wl-submitting');
      if(button)button.disabled=false;
    });
  });

  document.addEventListener('click',function(event){var link=event.target.closest('[data-wl-guide-link]');if(link&&!isUnlocked()){event.preventDefault();var gate=document.querySelector('[data-wl-gate="landing"]');if(gate){gate.scrollIntoView({behavior:'smooth',block:'center'});var input=gate.querySelector('[data-wl-input]');if(input)setTimeout(function(){input.focus();},500);}}var top=event.target.closest('[data-wl-top]');if(top){event.preventDefault();window.scrollTo({top:0,behavior:'smooth'});}});
  apply();
})();
